import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=05b6937e&scoped=true"
import script from "./PlanInfo.vue?vue&type=script&lang=js"
export * from "./PlanInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanInfo.vue?vue&type=style&index=0&id=05b6937e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6937e",
  null
  
)

export default component.exports